<style lang="less" >
.piccolumn1{
    display: flex;
    .ivu-upload-drag{
    background: transparent ;
    }
}

</style>
<template>
<div class="piccolumn1" style="margin-top:10px;">
    <div v-for="(item,index) in photosurl" :key="item.ID" style="position: relative;width:15vh;margin-right:10px;">
        <div style="position: absolute; width:100%;text-align:right;z-index:2;float:right;top:0px;right:0px;" @click="deletepic(index)">
            <img src="../../../../static/images/icon_delete.png" style="cursor:pointer" />
        </div>
        <div style="" v-viewer>
            <img :src="item.path" style="width:15vh;height:12.5vh;" />
        </div>
    </div>
    <Upload ref="upload" multiple :show-upload-list="false" :before-upload="handleBeforeUpload" :on-success="uplloadSucess" :format="['jpg','png']" :action="uploadUrl" :data="uploadData" type="drag" style="width:114px;">
        <div style="padding: 0.5vh;height:12vh;">            
            <Icon type="ios-cloud-upload-outline" size="42" />        
            <p style="height: 46px;line-height: 16px;">图片拖至此处或者单击选择图片</p>
        </div>
    </Upload>
</div>
</template>

<script>
export default {
    data() {
        return {
            pickeystr: "",
            photosurl: [], //存储照片
            photoindex: 0,
            photoinfo: "图片拖至此处或者单击选择图片",
            file: [],
            uploadFile: [],
            uploadData: {},
            uploadUrl: appurl.ip + "maintainService/YhPlanOrder.ashx?action=savepic"
        }
    },
    methods: {
        //删除照片
        deletepic: function (index) {
            this.photosurl.splice(index, 1);
            this.file.splice(index, 1);
            this.uploadFile.splice(index, 1);
        },
        handleBeforeUpload(file) {
            let src;
            src = URL.createObjectURL(file);
            let keyID = this.guid(); //Math.random().toString().substr(2);
            let obj = {
                ID: keyID,
                path: src
            };
            this.photosurl.push(obj);
            this.uploadData = {
                keyID: keyID
            };

            let promise = new Promise(resolve => {
                this.$nextTick(function () {
                    resolve(true);
                });
            });

            file["keyID"] = keyID;
            this.file.push(file);
            this.uploadFile.push(file);
            //URL.revokeObjectURL(src);
            this.photoinfo = "已选择【 " + this.uploadFile.length + " 】张图片";
            return promise;
        },
        //文件上传成功
        uplloadSucess(res, file) {
            this.photoindex++;
            if (this.photoindex >= this.uploadFile.length) {
                var pickey = "";
                this.pickeystr = "";
                for (let i = 0; i < this.uploadFile.length; i++) {
                    let item = this.file[i];
                    if (pickey != item.keyID) {
                        pickey = item.keyID;
                        if (this.pickeystr == "") this.pickeystr = pickey;
                        else this.pickeystr = this.pickeystr + "," + pickey;
                    }
                }
            }
        },
        //创建GUID
        guid: function () {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
                c
            ) {
                var r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    },
    mounted(){
        
    }
}
</script>



// WEBPACK FOOTER //
// imgUpload.vue?e2c8c63e